import { onError } from '@apollo/client/link/error';
import { OperationDefinitionNode } from 'graphql';

import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { EnvUtils } from '@/utils/env.utils';
import { appInsights } from '@/services/Telemetry/AppInsights.service';
import { CustomEventTypes } from '@/config/LogEventTypes.config';
import { RedirectionHelpers } from '../helpers/RedirectionHelpers';

export const redirectOnPage403Link = onError(({ forward, operation, graphQLErrors }) => {
  if (!graphQLErrors?.length) {
    return forward(operation);
  }

  graphQLErrors.forEach(({ extensions }) => {
    const operationType = (operation.query.definitions[0] as OperationDefinitionNode)?.operation;
    const errorCode = extensions?.code as string | undefined;
    const context = operation.getContext();

    const shouldRedirect = RedirectionHelpers.shouldRedirectTo403Page(operationType, errorCode);

    if (shouldRedirect && EnvUtils.isProduction()) {
      appInsights.trackEvent({ name: CustomEventTypes.REDIRECT_TO_PAGE_403 }, {
        urlFromRedirected: window.location.href,
        subscriptionid: context?.headers?.subscriptionid ?? null,
        organisationid: context?.headers?.organisationid ?? null,
      });
    }

    if (shouldRedirect) {
      browserHistory.push(getParameterizedLink('/not-authorized'));
    }
  });

  return undefined;
});
